
<div class="w-full bg-white">
  <div class="max-w-[1440px] mx-auto px-6 lg:px-8 pt-10 pb-24">
  
    <div class="mb-10 flex items-center justify-between gap-6 flex-wrap">
      <div>
        <h2
          class="text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight"
        >
          Today Trends
        </h2>
        <div
          class="mt-3 h-1.5 w-32 bg-gradient-to-r from-blue-600 via-yellow-400 to-yellow-500 rounded-full"
        ></div>
      </div>

    
      <div
        class="flex items-center bg-white shadow-sm px-3 py-2 w-80 rounded-lg border"
      >
        <mat-icon class="text-primary-600 text-lg -ml-1"> filter_alt </mat-icon>

        <mat-form-field
          appearance="outline"
          class="compact-form-field !m-0 flex-1"
          subscriptSizing="dynamic"
        >
          <mat-label>Search by date</mat-label>

          <input
            matInput
            [matDatepicker]="picker"
            (dateChange)="onDateChange($event.value)"
            placeholder="Search by date"
          />

          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>

          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <button
          *ngIf="selectedDate"
          mat-icon-button
          (click)="selectedDate = null; loadGazeti(1)"
          class="text-gray-500 hover:text-red-600 ml-1 transition"
          title="Clear filter"
        >
          <mat-icon class="text-lg">close</mat-icon>
        </button>
      </div>
    </div>
     <div
      *ngIf="!isLoadingNews && allNews?.length === 0"
      class="flex flex-col items-center justify-center py-32 text-center"
    >
      <img
        src="assets/images/empty.jpg"
        alt="No data"
        class="w-[520px] max-w-full opacity-90"
      />

    
    </div>

    <!-- ========================= -->
    <!-- GAZETI GRID (NO CAROUSEL) -->
    <!-- ========================= -->

    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
    >
      <!-- SKELETONS -->
      @if (isLoadingNews) { @for (item of [].constructor(8); track $index) {
      <div
        class="h-[420px] rounded-xl bg-white border shadow-sm p-4 animate-pulse"
      >
        <div class="h-56 bg-gray-200 rounded-lg"></div>
        <div class="mt-4 space-y-3">
          <div class="h-4 bg-gray-200 rounded w-3/4"></div>
          <div class="h-3 bg-gray-200 rounded w-1/2"></div>
        </div>
      </div>
      } }

  
      @for (theNew of allNews; track theNew.uuid) {
      <div
        class="group cursor-pointer bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition"
        (click)="onReadMore(theNew)"
      >
    
      <div class="relative h-80 bg-gray-100 border-b border-gray-100 overflow-hidden flex justify-center items-start transition-all duration-500 group-hover:bg-gray-200">
  
  <img
    [src]="theNew.thumbnailUrl || 'assets/images/default-newspaper.jpg'"
    [alt]="theNew.title"
    class="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
    (error)="onImageError($event)"
    loading="lazy"
  />

  <div class="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>

  <div class="absolute top-0 right-1 bg-primary-300 text-white px-3 py-1.5 rounded-sm text-[10px] font-bold shadow-lg z-10">
    {{ formatDate(theNew.publicationDate) }}
  </div>
</div>

    
        <div
          class="p-5 flex flex-col gap-3 h-[190px] bg-white/90 group-hover:bg-primary-500 backdrop-blur-sm w-full"
        >
          <div class="flex justify-between items-start gap-2">
            <h3
              class="!my-0 text-xl md:text-2xl font-extrabold text-blue-800 group-hover:text-yellow-300 line-clamp-2 flex-1 pr-4"
            >
              {{ theNew.title }}
            </h3>
            <p
              class="!my-0 text-lg !font-bold text-gray-700 group-hover:text-white"
            >
              {{ theNew.publicationNumber }}
            </p>
          </div>

          @if (theNew.description) {
          <p
            class="text-sm text-gray-600 group-hover:text-white !font-bold line-clamp-2 flex-1 pr-4"
          >
            {{ theNew.description }}
          </p>
          }

          <div
            class="flex items-center gap-2 text-primary-400 font-semibold whitespace-nowrap animate-reading-pulse group-hover:text-primary-50 cursor-pointer"
          >
            <mat-icon class="text-base">menu_book</mat-icon>
            <span>Start Reading</span>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
<app-corporate-books-trends></app-corporate-books-trends>
<app-corporate-magazines-trends></app-corporate-magazines-trends>
